module.exports = __webpack_public_path__ + "img/marker-icon-drone-offline.506bb23f.png";